import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcFlightFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m12.127 20.216-4.123 1.486A.75.75 0 0 1 7 20.997v-2.228c0-.439.23-.846.607-1.072L9.5 16.561v-1.75l-6.407.8a.75.75 0 0 1-.843-.744v-.557a2.75 2.75 0 0 1 1.652-2.522L9.5 9.351V4.75a2.5 2.5 0 0 1 5 0v4.601l5.598 2.437a2.75 2.75 0 0 1 1.652 2.522v.557a.75.75 0 0 1-.843.744l-6.407-.8v1.752l1.944 1.138c.383.224.619.635.619 1.079v2.199a.75.75 0 0 1-1.013.703z"
  }));
}
var IcFlightFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcFlightFill));

export { IcFlightFill as I };
